import React, { SVGProps } from "react";

const GeolocationIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d={
					"M10.01 1.5C6.07001 1.5 2.89999 4.63 2.89999 8.46C2.89999 10.37 3.93001 12.92 5.42001 15.02C6.16001 16.06 6.98 16.95 7.81 17.57C8.64 18.2 9.40002 18.51 10.02 18.51C10.64\
 18.51 11.4 18.21 12.23 17.57C13.05 16.95 13.88 16.06 14.62 15.02C16.11 12.92 17.14 10.38 17.14 8.46C17.14 4.63 13.97 1.5 10.03 1.5H10.01ZM1.39999 8.46C1.39999 3.77 5.27001 0\
 10.01 0C14.75 0 18.62 3.77 18.62 8.46C18.62 10.8 17.41 13.65 15.82 15.89C15.02 17.02 14.09 18.03 13.12 18.76C12.16 19.49 11.09 20 10 20C8.91 20 7.84 19.49 6.88 18.76C5.91 18.02\
 4.97999 17.01 4.17999 15.89C2.58999 13.66 1.38 10.81 1.38 8.46H1.39999ZM10.01 6.35C8.77001 6.35 7.76001 7.36 7.76001 8.6C7.76001 9.84 8.77001 10.85 10.01 10.85C11.25 10.85 12.26\
 9.84 12.26 8.6C12.26 7.36 11.25 6.35 10.01 6.35ZM6.26001 8.6C6.26001 6.53 7.94001 4.85 10.01 4.85C12.08 4.85 13.76 6.53 13.76 8.6C13.76 10.67 12.08 12.35 10.01 12.35C7.94001\
 12.35 6.26001 10.67 6.26001 8.6Z"
				}
			/>
		</svg>
	);
};

export default GeolocationIcon;
